import { render, staticRenderFns } from "./FlightFilterLeg.vue?vue&type=template&id=2c5900a0&scoped=true"
import script from "./FlightFilterLeg.vue?vue&type=script&lang=js"
export * from "./FlightFilterLeg.vue?vue&type=script&lang=js"
import style0 from "./FlightFilterLeg.vue?vue&type=style&index=0&id=2c5900a0&prod&lang=scss&scoped=true"
import style1 from "./FlightFilterLeg.vue?vue&type=style&index=1&id=2c5900a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5900a0",
  null
  
)

export default component.exports